import { IIngredient } from "Domain/Model/Ingredient/Ingredient";

export const CREATE_INGREDIENT_REQUEST = 'CREATE_INGREDIENT_REQUEST';

export const createIngredientRequest = ( ingredientData: IIngredient ) => ({
    type: CREATE_INGREDIENT_REQUEST,
    payload: { ...ingredientData },
});
